export const collections = {
  K5METADATA: "k5metadata",
  USERS: "users",
  PROFESSIONALS: "professionals",
  ORDERS: "orders",
  REVIEWS: "reviews",
  STAFFS: "staffs",
  PRODUCTS: "products",
  CATEGORIES: "categories",
  WORKOUTS: "workouts",
  GALLERY: "gallery",
};

export const documents = {
  CATEGORIES: "categories",
  COUPONS: "coupons",
  SHOP: "shop",
  BRANDS: "brands",
  ATTRIBUTES: "attributes",
  PRODUCTTYPE: "productType",
  WORKOUTS: "workouts",
  CAROUSEL: "carousel",
  BANNER: "banner",
  CLIENTS: "clients",
  SEARCHKEYS: "searchKeys",
  SEARCHKEYSADMIN: "searchKeysAdmin",
  GENDERFILTER: "genderFilter",
  HOMESECTIONS: "homeSections",
};

export const constants = {
  EXPIRY_THRESHOLD: 30,
  STOCK_THRESHOLD: 1, //If changed need to change in cloud functions as well.
  SUBCATEGORIES: "subcategories",
  WORKOUTS: "workouts",
  PAYMENT_CASH: "COD",
  PAYMENT_ONLINE: "Pre_paid", //For Delivery
  PAYMENT_ONLINE_ORDER: "Prepaid", //For Order while checkout
  PAYMENT_PICKUP: "Pickup",
  PAYMENT_REPL: "REPL",
  EDIT_DELIVERY_ALLOWED: [
    "Manifested",
    "In Transit",
    "Pending",
    "Scheduled",
    "Not Picked",
  ],
  EDIT_DELIVERY_ALLOWED_NOT_ALLOWED: [],
  FORWARD_SHIPMENT: {
    STATUS: [
      "Manifested",
      "In Transit",
      "Dispatched",
      "Delivered",
      "RTO",
      "Returned",
    ],
    STATUS_TYPE: ["UD", "DL", "RT"],
    // STATUS_COMBINATION:["UD_Manifested","UD_In Transit","UD_Dispatched", "DL_Delivered", "RT_In Transit","RT_Dispatched","DL_RTO" ],
    CANCELLATION_ALLOWED: [
      "UD_Manifested",
      "UD_In Transit",
      "UD_Pending",
      "RT_In Transit",
      "RT_Pending",
      "UD_Not Picked",
    ],
    CANCELLATION_NOT_ALLOWED: [
      "UD_Dispatched",
      "DL_Delivered",
      "RT_Dispatched",
      "DL_RTO",
    ],
    STATUS_COMBINATION: {
      Manifested: ["UD_Manifested"],
      "In Transit": ["UD_In Transit", "RT_In Transit"],
      "Out For Delivery": ["UD_Dispatched", "RT_Dispatched"],
      Delivered: ["DL_Delivered"],
      Returned: ["DL_RTO"],
    },
  },
  BACKWARD_SHIPMENT: {
    STATUS: [
      "Scheduled",
      "In Transit",
      "Dispatched",
      "DTO",
      "Canceled",
      "Closed",
      "Cancelled",
    ],
    STATUS_TYPE: ["PP", "PU", "DL", "CN"],
    // STATUS_COMBINATION:["PP_Scheduled","PP_Dispatched","PU_In Transit","PU_Dispatched", "DL_DTO"],
    CANCELLATION_ALLOWED: ["PP_Scheduled", "PU_In Transit", "PU_Pending"],
    CANCELLATION_NOT_ALLOWED: ["PP_Dispatched", "PU_Dispatched", "DL_DTO"],
    STATUS_COMBINATION: {
      Scheduled: ["PP_Scheduled"],
      "In Transit": ["PU_In Transit"],
      "Out For Delivery": ["PP_Dispatched", "PU_Dispatched"],
      Delivered: ["DL_DTO"],
    },
  },
  RETURN_POLICY: 7,
  nodeserver: "https://us-central1-k5-prod.cloudfunctions.net",
  // nodeserver: "http://192.168.178.122:4000"
};
